export default __webpack_public_path__ + "3f925570fd74cc4cd5e4f6acf69e5659.png";